import 'element-closest';
import 'string.prototype.endswith';
import 'custom-event-autopolyfill';
import "babel-polyfill";
import 'whatwg-fetch';
import './lib/polyfills/array-find';
import './lib/polyfills/for-each';
import 'classlist-polyfill';
import 'helpers/ensure';

import './lib/components/carouselRefactor/carousel';
import './lib/components/carouselRefactor/productCarousel';
import './lib/components/breadcrumbs-back-button';
import './lib/pages/product-page';
import './lib/pages/global';
import './lib/pages/never-knowingly-undersold-claim-page';
import './lib/pages/component-library';
import './lib/pages/hero-content';
import './lib/components/close-overlay-message';
import './lib/components/create-new-password-form';
import './lib/components/footer-sign-up-form';
import './lib/components/request-new-password-form';
import './lib/components/show-hide';
import './lib/components/swatch-list';
import './lib/components/bundle-list';
import './lib/components/tooltips';
import './lib/components/quantity-field';
import './lib/components/facets-department-list';
import './lib/components/add-to-basket-form';
import './lib/components/add-listing-page-item-to-basket';
import './lib/components/notifications';
import './lib/components/tooltips/tooltips';
import './lib/components/accordions';
import './lib/components/reviews';
import './lib/components/additional-services-accordion-setup';
import './lib/components/skip-links';
import './lib/components/header-skip-links';
import './lib/components/sort-select';
import './lib/components/numeric-input-maxlength';
import './lib/components/video-viewer';
import './lib/components/email-stock-notification';
import './lib/components/responsive-table';
import './lib/components/cms-carousel';
import './lib/components/cms-carousel-banner';
import './lib/components/cms-iframe';
import './lib/components/cms-image-caption';
import './lib/components/email-signup/HeaderBanner';
import './lib/components/email-signup/FooterBanner';
import './lib/components/UNTESTED-touch-hover-check';
import './lib/components/sticky-summary-block';

import initFeatureDetection from './lib/helpers/feature-detection';

function main() {
  initFeatureDetection();
}

main();
